import Image from 'next/image'

import type { EshopListItemAPI } from '@twisto/api-cms/custom-types'
import { useAppConfig } from '@twisto/base'

import { AccessibleDiv } from '../atoms'

import { getEshopImageUrl } from './eshop-card.helpers'
import * as styles from './eshop-card.styles'

type EshopCardProps = {
  shop: EshopListItemAPI
  origin: string
  variant?: 'default' | 'compact'
}

export const EshopCard = ({
  shop,
  origin,
  variant = 'default',
}: EshopCardProps) => {
  const { region } = useAppConfig()

  const { name, url, imgLogo, imgBackground, imgLogoWhite } = shop

  const background = getEshopImageUrl(imgBackground, origin, region)
  const whiteLogo = getEshopImageUrl(imgLogoWhite, origin, region)
  const logo = getEshopImageUrl(imgLogo, origin, region)
  const isCompact = variant === 'compact'

  return (
    <AccessibleDiv
      css={isCompact ? styles.compact : styles.eshop}
      role="link"
      onActivate={() => window.open(url, '_blank')}
    >
      {isCompact ? (
        logo ? (
          <Image
            unoptimized
            alt={name}
            css={styles.logo}
            height={330}
            src={logo}
            width={330}
          />
        ) : (
          <span css={styles.name}>{name}</span>
        )
      ) : (
        <div css={styles.content}>
          <div
            className="eshop__background"
            css={[styles.backgroundWrap, !!whiteLogo && styles.overlay]}
          >
            {background && (
              <Image
                unoptimized
                alt="Eshop Background"
                css={styles.background}
                height={330}
                src={background}
                width={330}
              />
            )}
          </div>
          {whiteLogo && (
            <Image
              unoptimized
              alt="Eshop Logo"
              css={styles.foreground}
              height={58}
              src={whiteLogo}
              width={230}
            />
          )}
        </div>
      )}
    </AccessibleDiv>
  )
}
